module.exports = __webpack_public_path__ + "img/close.a2e1651a.png";